import { db } from "./firebase-init";
import { getBits } from "../utils/localStorage";

const bits = getBits();
const winesCollection = db.collection(process.env.VUE_APP_WINE + bits);

export function updateProduct(item) {
  return winesCollection.doc(item.id).update(item.data);
}
